<script setup lang="ts">
import { computed } from 'vue'
import type { Menu } from '~/types'

interface Props {
  item: Menu.MenuItem
  navPos?: string
  navLayer?: string
}

const props = defineProps<Props>()

const columnCustomClass = computed<string | undefined>(() => props.item.data?.['customClass'] || undefined)
</script>

<template>
  <li
    :class="columnCustomClass"
    class="header__nav-submenu-column"
  >
    <h3 v-if="item.name">
      {{ item.name }}
    </h3>
    <ul>
      <template v-for="childrenMenuItem in item.children">
        <Component
          :is="childrenMenuItem.component"
          v-if="childrenMenuItem?.component"
          :key="childrenMenuItem.id"
          :item="childrenMenuItem"
          :nav-pos="navPos"
          :nav-layer="navLayer"
        />
      </template>
    </ul>
  </li>
</template>

<style lang="scss">
.header__nav-submenu-column {
  @apply w-full mb-[30px] px-[20px];
  @apply 2xl:w-1/3;

  h3 {
    @apply text-[18px] font-semibold mb-[10px] pb-[5px] border-b border-b-dark-text;
  }

  &.hide-title h3 {
    @apply hidden;
  }

  ul {
    li {
      @apply mb-[5px] last:mb-0;

      a {
        @apply text-[16px];
      }
    }
  }
}
</style>
